<template>
  <div class="swiper-banner-container">
    <swiper ref="swiperRef" :options="swiperOptions" v-if="swiperList">
      <swiper-slide class="slide-content" v-for="(item, index) in swiperList" :key="item.id">
        <bannerItem ref="bannerRef" :slide="index" :info="item" :key="item.id"></bannerItem>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <div class="swiper-outer-button">
      <div class="swiper-inner-button weapon-cases-main-width">
        <div class="custon-button-prev swiper-button-prev">
          <svg-icon icon-class="matr1x_fire_weapon_cases_arrow_left" class-name="btn-svg"></svg-icon>
        </div>
        <div class="custon-button-next swiper-button-next">
          <svg-icon icon-class="matr1x_fire_weapon_cases_arrow_right" class-name="btn-svg"></svg-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import responsiveMixin from "@/mixins/responsive";
import bannerItem from "./item.vue";
import "swiper/css/swiper.css";

export default {
  mixins: [responsiveMixin],
  components: { bannerItem },
  data() {
    return {
      swiperOptions: {
        observer: true,
        observeParents: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        loop: true,
        centeredSlides: true,
        setWrapperSize: true,
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
          bulletClass: "custom-bullet",
          bulletActiveClass: "custom-bullet-active",
        },
        navigation: {
          nextEl: ".custon-button-next",
          prevEl: ".custon-button-prev",
        },
        on: {}
      },
      swiperList: null
    };
  },
  props: {
    bannerList: {
      type: Array,
      default: () => []
    }
  },
  mounted() { },
  beforeDestroy() { },
  methods: {},
  watch: {
    bannerList: {
      handler(newValue) {
        this.swiperList = newValue;
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
